module.exports = __webpack_public_path__ + "static/media/musio_campaign.52c71dad.png";